import React, { useState } from "react";
import caseStudies from "../data/CaseStudies";
import "../styles/CaseStudyComponent.css";

const CaseStudyComponent = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [showAll, setShowAll] = useState(false);

  const toggleCase = (index) => {
    setExpandedIndex(index === expandedIndex ? null : index);
  };

  const toggleShowAll = () => {
    setShowAll(!showAll);
    setExpandedIndex(null); // 全て表示/閉じる時に展開をリセット
  };

  const displayedCases = showAll ? caseStudies : caseStudies.slice(0, 4);

  return (
    <div className="elt-wp-plugin case-study-component">
      <div className="case-list">
        {displayedCases.map((caseItem, index) => (
          <div
            key={index}
            className={`case-item ${expandedIndex === index ? "expanded" : ""}`}
          >
            <div className="case-header" onClick={() => toggleCase(index)}>
              <span className="case-format">{caseItem.details.format}</span>

              <div className="case-title-container">
                <span className="title">{caseItem.title}</span>
                <span className="recipient">{`(${caseItem.details.recipient})`}</span>
              </div>
            </div>

            {expandedIndex === index && (
              <div className="case-details">
                <h4>受講前の背景と課題</h4>
                <ul>
                  {caseItem.details.challenges.map((challenge, index) => (
                    <li key={index}>{challenge}</li>
                  ))}
                </ul>
                <h4>目標</h4>
                <ul>
                  {caseItem.details.needs.map((need, index) => (
                    <li key={index}>{need}</li>
                  ))}
                </ul>
                <h4>受講後の効果</h4>
                <ul>
                  {caseItem.details.results.map((result, index) => (
                    <li key={index}>{result}</li>
                  ))}
                </ul>
                {/* 閉じるボタン */}
                <button className="close-button" onClick={() => setExpandedIndex(null)}>
                  閉じる
                </button>
              </div>
            )}
          </div>
        ))}
        {/* "もっと表示する"または"閉じる"ボタン */}
        <button className="toggle-button" onClick={toggleShowAll}>
          {showAll ? "閉じる" : "もっと表示する"}
        </button>
      </div>
    </div>
  );
};

export default CaseStudyComponent;

